import React, { useState } from "react";
import './index.scss';

const ReadMoreLess = ({ text, truncLength }) => {
  const [isShow, setShowHide] = useState(false);
  const isTruncated = text.length > truncLength;

  return (
    <div className="content">
      {isShow ? text : text.substring(0, truncLength) + (isTruncated ? "..." : "")}
      {isTruncated && (
        <button className="more" onClick={() => setShowHide((previous) => !previous)}>
          {isShow ? "Read Less" : "Read More"}
        </button>
      )}
    </div>
  );
};

export default ReadMoreLess;